import React, { useEffect } from 'react'
import BaseModal from './BaseModal'
import { Container, Modal, Row } from 'react-bootstrap'
import goldPopup from 'assets/images/eventBoatRacing/imgGold.png'
import coinBannerBg from 'assets/images/eventBoatRacing/bgGoldBanner.png'
import coinImg from 'assets/images/eventBoatRacing/imgCoin.png'
import { useTranslation } from 'react-i18next'

function GoldPopupModal({ show, onHide, coin, ...otherProps }) {
	const { t } = useTranslation()

  useEffect(() => {
    let timeoutId;
    if (show) {
      timeoutId = setTimeout(() => {
        onHide()
      }, 3000)
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [show])

	return (
		<BaseModal
			show={show}
			onHide={onHide}
			hideDecor={true}
			congrats
			{...otherProps}
		>
			<Modal.Body className="py-0">
				<p className="text-center popup-title">
					{t('event.boat_racing.popup.reward.gold').replace(
						'_GOLD_',
						coin || 100,
					)}
				</p>

				<div className="popup-content d-flex justify-content-center position-relative">
					<img src={goldPopup} alt="" width={195} />
					<div className="position-absolute popup-content-banner">
						<img srcSet={`${coinBannerBg} 2x`} alt="Coin banner" />
						<div className="d-flex justify-content-center align-items-center position-absolute">
							<span className="popup-content-text text-large">
								{coin || 100}
							</span>
							<img src={coinImg} alt="" width={27} />
						</div>
					</div>
				</div>
			</Modal.Body>
		</BaseModal>
	)
}

export default GoldPopupModal
